<div class="card-round margin-bottom-32" style="flex-direction: row; align-items: center;"
  *ngIf="location['status'] == 'Wird überprüft'">
  <mat-icon>warning</mat-icon>Wir überprüfen deine Infos und stellen dein Profil live, sobald der Prozess beendet ist.
</div>
